// extracted by mini-css-extract-plugin
export default {"likeButton":"jR-z","unLikedButton":"kR-z","likedButton":"lR-z"};